import "./App.css";
import fondo from "./assets/fondo2.jpeg";
import maquetas from "./assets/maquetas.jpeg";
import juguetes from "./assets/juguetes.jpeg";
import gears from "./assets/gears.jpeg";
// import photos from "./photos";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Slider from "./components/Slider";
// import PhotoAlbum from "react-photo-album";
import ServicesContainer from "./components/ServicesContainer";

function App() {
  const navbarLinks = [
    { url: "#", title: "Home" },
    { url: "#", title: "Servicios" },
    { url: "#", title: "Contacto" },
  ];

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const goToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  const goTo = [goToTop, goToBottom, goToBottom];

  return (
    <div className="app">
      <div className="opacity">
        <Navbar navbarLinks={navbarLinks} goTo={goTo} />
        <Hero imageSrc={fondo} />
        <Slider
          imageSrc={gears}
          title={"Precision y Funcionalidad"}
          subtitle={
            "Confía en nosotros para la impresión de piezas funcionales. Desde engranajes de precisión hasta componentes industriales, nuestra tecnología de impresión 3D de vanguardia garantiza la calidad y la funcionalidad que necesitas"
          }
        />
        <Slider
          imageSrc={juguetes}
          title={"Magia en 3D"}
          subtitle={
            "Explora un mundo de creatividad con nuestra impresión 3D de juguetes y figuras. Desde juguetes educativos hasta personajes icónicos, damos vida a tus ideas en forma de objetos tangibles"
          }
          flipped={true}
        />
        <Slider
          imageSrc={maquetas}
          title={"Pequeños Mundos, Grandes Detalles"}
          subtitle={
            "Crea modelos a escala impresionantes con nuestra tecnología de impresión 3D. Desde maquetas arquitectónicas hasta réplicas detalladas, cada proyecto se convierte en una obra maestra a escala."
          }
        />
        <ServicesContainer />
        <Footer />
      </div>
    </div>
  );
}

export default App;
